<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NPFug0/tc-custom/9780765392657.jpg?1731797218314" alt="This image is the cover for the book All Those Explosions Were Someone Else's Fault"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">All Those Explosions Were Someone Else's Fault
      </h1>
      <p class="bookDescription body article font2">
        <p>Monsters are real.<br/>But so are heroes.<br/><br/>Sparks are champions of weird science. Boasting capes and costumes and amazing super-powers that only make sense if you don’t think about them too hard, they fight an eternal battle for truth and justice . . . mostly.<br/><br/>Darklings are creatures of myth and magic: ghosts, vampires, were-beasts, and the like. Their very presence warps reality. Doors creak at their approach. Cobwebs gather where they linger. <br/><br/>Kim Lam is an ordinary college student until a freak scientific accident (what else?) transforms Kim and three housemates into Sparks—and drafts them into the never-ending war between the Light and Dark.  They struggle to master their new abilities—and (of course) to design cool costumes and come up with great hero-names.<br/><br/>Turns out that “accident” was just the first salvo in a Mad Genius’s latest diabolical scheme. Now it’s up to four newbie heroes to save the day, before they even have a chance to figure out what their team’s name should be!<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Alan Gardner
      </h2>
      
      <p class="authorDescription body article">James A. Gardner is the author of seven science fiction novels and one collection of short stories. Gardner lives in Kitchener, Ontario, Canada.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6488da06